import React, { useState } from "react";
import { Form, Button, Modal, Checkbox, Message, Icon } from "semantic-ui-react";
import { determineEffluentUnits } from "../../../../utils/dataAndFormulas/effluentForms";
import { useLanguage } from "../../../../contexts";
import "./UpdateUnitsModal.scss";

export function UpdateUnitsModal(props) {
  const { show, onClose, onApply, currentUnits, registeredFields, isLoading } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Estado para campos seleccionados y sus unidades
  const [selectedFields, setSelectedFields] = useState({});
  const [fieldUnits, setFieldUnits] = useState({});

  // Lista de todos los campos de efluentes
  const allEffluentFields = [
    { key: "domestic_effluents", label: t("domestic_effluents") },
    { key: "industrial_effluents", label: t("industrial_effluents") },
    { key: "combined_effluents", label: t("combined_effluents") },
    { key: "sludge_and_mud", label: t("sludge_and_mud") },
    { key: "recycled_effluents", label: t("recycled_effluents") },
    { key: "treatment_cost_domestic_effluents", label: t("treatment_cost_domestic_effluents") },
    { key: "industrial_effluent_treatment_cost", label: t("industrial_effluent_treatment_cost") },
    { key: "combined_treatment_cost", label: t("combined_treatment_cost") },
    { key: "sludge_treatment_cost", label: t("sludge_treatment_cost") },
  ];

  // Filtrar campos según registeredFields si existen
  const effluentFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
            code: field.code,
          }))
      : allEffluentFields;

  const handleFieldToggle = (fieldKey, checked) => {
    setSelectedFields(prev => ({
      ...prev,
      [fieldKey]: checked
    }));

    // Si se selecciona, inicializar con la unidad actual
    if (checked && !fieldUnits[fieldKey]) {
      setFieldUnits(prev => ({
        ...prev,
        [fieldKey]: currentUnits?.[fieldKey] || ""
      }));
    }
  };

  const handleUnitChange = (fieldKey, unit) => {
    setFieldUnits(prev => ({
      ...prev,
      [fieldKey]: unit
    }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    const allUnits = {};
    effluentFields.forEach(field => {
      allSelected[field.key] = true;
      allUnits[field.key] = currentUnits?.[field.key] || "";
    });
    setSelectedFields(allSelected);
    setFieldUnits(allUnits);
  };

  const handleDeselectAll = () => {
    setSelectedFields({});
  };

  const handleApply = () => {
    // Filtrar solo los campos seleccionados con sus unidades
    const unitsToApply = {};
    Object.keys(selectedFields).forEach(key => {
      if (selectedFields[key] && fieldUnits[key]) {
        unitsToApply[key] = fieldUnits[key];
      }
    });

    if (Object.keys(unitsToApply).length === 0) {
      return;
    }

    onApply(unitsToApply);
  };

  const selectedCount = Object.values(selectedFields).filter(Boolean).length;

  return (
    <Modal open={show} onClose={onClose} size="large" className="update-units-modal">
      {/* <Modal.Header>
        <Icon name="edit" />
        {t("update_units_in_forms") || "Modificar unidades en formularios existentes"}
      </Modal.Header> */}
      <Modal.Content scrolling>
        <div className="update-units-modal__title">{t("update_units_in_forms") || "Modificar unidades"}</div>
        {/* <Message info>
          <Message.Header>{t("select_fields_to_update") || "Selecciona los campos a modificar"}</Message.Header>
          <p>
            {t("update_units_description") ||
              "Selecciona los campos y las unidades que deseas aplicar a todos los formularios existentes del año."}
          </p>
        </Message> */}

        <div style={{ marginBottom: "15px" }}>
          <Button size="small" className="btn-select-all" onClick={handleSelectAll}>
            <Icon name="check square" /> {t("select_all") || "Seleccionar todos"}
          </Button>
          <Button size="small" className="btn-deselect-all" onClick={handleDeselectAll}>
            <Icon name="square outline" /> {t("deselect_all") || "Deseleccionar todos"}
          </Button>
          <span style={{ marginLeft: "15px", color: "#666" }}>
            {selectedCount} {t("fields_selected") || "campos seleccionados"}
          </span>
        </div>

        <Form>
          <div className="update-units-grid">
            {effluentFields.map((field) => (
              <div key={field.key} className="update-unit-row">
                <Checkbox
                  checked={selectedFields[field.key] || false}
                  onChange={(_, data) => handleFieldToggle(field.key, data.checked)}
                  label={field.label}
                  className="field-checkbox"
                />
                {selectedFields[field.key] && (
                  <Form.Dropdown
                    placeholder={t("select_unit")}
                    options={determineEffluentUnits(field.key).map((unit) => ({
                      key: unit.key,
                      text: t(unit.name),
                      value: unit.value,
                    }))}
                    selection
                    search
                    compact
                    value={fieldUnits[field.key] || ""}
                    onChange={(_, data) => handleUnitChange(field.key, data.value)}
                    className="unit-dropdown"
                  />
                )}
              </div>
            ))}
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          primary
          onClick={handleApply}
          disabled={selectedCount === 0 || isLoading}
          loading={isLoading}
        >
          <Icon name="save" />
          {t("apply_to_forms") || `Aplicar a formularios (${selectedCount})`}
        </Button>
        <Button secondary onClick={onClose} disabled={isLoading}>
          {t("cancel")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
